// 2_components/delivery_tooltip.js
// Custom delivery-date tooltip. CZ adds Saturday Zásilkovna copy + logo;
// SK/PL keep the same card with the admin title only. Called from
// product_product_top.js and ordering_process_1.js — no init().

const ZASILKOVNA_LOGO_URL = "/user/documents/upload/assets/zasilkovna-logo-bg-white.png";
const EMPHASIZE_PHRASES = ["ještě ten den", "v ten istý deň", "tego samego dnia"];

function escapeDeliveryTooltipHtml(text) {
	const div = document.createElement("div");
	div.textContent = text;
	return div.innerHTML;
}

function formatDeliveryTooltipHtml(rawTitle) {
	let html = escapeDeliveryTooltipHtml(rawTitle.trim());
	const commaIndex = html.indexOf(",");
	if (commaIndex > 0) {
		html = "<strong>" + html.slice(0, commaIndex) + "</strong>" + html.slice(commaIndex);
	}
	EMPHASIZE_PHRASES.forEach((phrase) => {
		html = html.replace(phrase, "<strong>" + phrase + "</strong>");
	});
	return html;
}

function buildDeliveryTooltipElement(rawTitle) {
	const tooltip = document.createElement("span");
	tooltip.className = "nat-delivery-tooltip";
	tooltip.setAttribute("role", "tooltip");

	const text = document.createElement("span");
	text.className = "nat-delivery-tooltip__text";
	text.innerHTML = formatDeliveryTooltipHtml(rawTitle);
	tooltip.appendChild(text);

	const extraText = window.NAT.translations("deliveryTooltipSaturday");
	if (!extraText) {
		return tooltip;
	}

	const divider = document.createElement("span");
	divider.className = "nat-delivery-tooltip__divider";

	const extra = document.createElement("span");
	extra.className = "nat-delivery-tooltip__extra";
	extra.textContent = extraText;

	const logo = document.createElement("img");
	logo.className = "nat-delivery-tooltip__logo";
	logo.src = ZASILKOVNA_LOGO_URL;
	logo.alt = "Zásilkovna";
	logo.width = 144;
	logo.height = 47;

	tooltip.appendChild(divider);
	tooltip.appendChild(extra);
	tooltip.appendChild(logo);
	return tooltip;
}

function enhanceDeliveryTooltipTrigger(trigger) {
	if (!trigger || trigger.classList.contains("nat-delivery-tooltip-trigger")) {
		return;
	}
	const rawTitle = (trigger.getAttribute("data-original-title") || trigger.getAttribute("title") || "").trim();
	if (!rawTitle) {
		return;
	}

	trigger.classList.add("nat-delivery-tooltip-trigger");
	trigger.classList.remove("show-tooltip");
	trigger.setAttribute("tabindex", "0");
	trigger.removeAttribute("title");
	trigger.removeAttribute("data-original-title");
	trigger.appendChild(buildDeliveryTooltipElement(rawTitle));
}

export function enhanceDeliveryTooltips(root) {
	if (!root) {
		return;
	}
	root.querySelectorAll(".delivery-time .show-tooltip").forEach(enhanceDeliveryTooltipTrigger);
}

export function disableBootstrapDeliveryTooltips() {
	document.querySelectorAll(".nat-delivery-tooltip-trigger").forEach((trigger) => {
		const $el = $(trigger);
		if ($el.data("bs.tooltip")) {
			$el.tooltip("destroy");
		}
		trigger.removeAttribute("title");
		trigger.removeAttribute("data-original-title");
	});
}

export function bindDeliveryTooltipInteractions() {
	document.querySelectorAll(".nat-delivery-tooltip-trigger").forEach((trigger) => {
		if (trigger.dataset.natDeliveryBound) {
			return;
		}
		trigger.dataset.natDeliveryBound = "1";
		trigger.addEventListener("click", function (e) {
			if (!window.NAT.media.isMobile) {
				return;
			}
			e.preventDefault();
			e.stopPropagation();
			const wasOpen = trigger.classList.contains("is-open");
			document.querySelectorAll(".nat-delivery-tooltip-trigger.is-open").forEach((el) => {
				el.classList.remove("is-open");
			});
			if (!wasOpen) {
				trigger.classList.add("is-open");
			}
		});
	});

	if (!document.body.dataset.natDeliveryOutsideBound) {
		document.body.dataset.natDeliveryOutsideBound = "1";
		document.addEventListener("click", function (e) {
			if (e.target.closest(".nat-delivery-tooltip-trigger")) {
				return;
			}
			document.querySelectorAll(".nat-delivery-tooltip-trigger.is-open").forEach((el) => {
				el.classList.remove("is-open");
			});
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", disableBootstrapDeliveryTooltips);
	} else {
		disableBootstrapDeliveryTooltips();
	}
}
